import 'angular:locale/data:fr';
import './src/polyfills.ts';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "fr";
